Ext.define('SA.view.DeleteCustomLocationWindow', {
    alias: 'widget.delete-custom-location-window',
    extend: 'SA.view.PromptWindow',

    includeCancelBtn: true,
    includeOkBtn: true,
    okAction: 'onOkClick',
    title: 'Delete in-use custom location',

    getBodyItems() {
        return {
            xtype: 'component',

            data: this.projects.map(project => {
                return Ext.util.Format.htmlEncode(project.getName());
            }),

            tpl: [
                '<p>',
                    'Are you sure you want to delete this location? ',
                    'This custom location is being used in the following ',
                    'project<tpl if="length &gt; 1">s</tpl>: ',
                '</p>',
                '<ul>',
                    '<tpl for=".">',
                        '<li>{.}</li>',
                    '</tpl>',
                '</ul>',
                '<p>',
                    'Please click "OK" to remove the location from ',
                    '<tpl if="length &gt; 1">these projects ',
                    '<tpl else>this project </tpl>',
                    'and delete the location from your account.',
                '</p>'
            ]
        };
    },

    onOkClick() {
        this.handler();

        this.destroy();
    }
});
